import { closePanel, destroyPanel, initPanel } from '@phoenix/helpers/panel-helper';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    classes: {
      type: Array,
      default: () => [],
    },
    headerClasses: {
      type: Array,
      default: () => [],
    },
    contentClasses: {
      type: Array,
      default: () => [],
    },
    footerClasses: {
      type: Array,
      default: () => [],
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    headerTitleClass: {
      type: String,
      default: 'h4',
    },
    headerBordered: {
      type: Boolean,
      default: true,
    },
    footerBordered: {
      type: Boolean,
      default: true,
    },
    boxedContent: {
      type: Boolean,
      default: true,
    },
    initPanel: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      defaultOptions: {},
    };
  },

  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },

    _classes() {
      return ['panel', { 'panel--reverse': this.reverse }, ...this.classes];
    },

    _contentClasses() {
      return ['panel__content', { 'panel__content--boxed': this.boxedContent }, ...this.contentClasses];
    },

    hasTitle() {
      return this.title !== '';
    },
  },

  mounted() {
    if (this.initPanel) {
      initPanel(this.id, {
        ...this.defaultOptions,
        ...this.options,
      });
    }
  },

  unmounted() {
    destroyPanel(this.id);
  },

  methods: {
    close() {
      closePanel(this.id);
    },
  },
};
